import { render, staticRenderFns } from "./MultiSearchTableAdmin.vue?vue&type=template&id=71de2952&scoped=true"
import script from "./MultiSearchTableAdmin.vue?vue&type=script&lang=js"
export * from "./MultiSearchTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71de2952",
  null
  
)

export default component.exports